const useOverridesTaskExtraFields = (name, values, params) => {
  const extraParams = { ...params };

  if (name === 'Policy Overrides' || name === 'Offer Overrides') {
    switch (values.overrideAction) {
      case 'Override Branded Title':
        extraParams.VIN = {
          type: 'shorttext',
          name: 'VIN (Optional)'
        };
        break;
      case 'Override MSRP Too High':
        extraParams.VIN = {
          type: 'shorttext',
          name: 'VIN (Optional)'
        };
        break;
      case 'Override Excluded VIN':
        extraParams.VIN = {
          type: 'shorttext',
          name: 'VIN (Optional)'
        };
        break;
      case 'Override Replacement Cost Values':
        extraParams.valuationID = {
          type: 'shorttext',
          name: 'Replacement Cost Valuation ID'
        };
        extraParams.coverageAOrC = {
          type: 'integer',
          name: 'Coverage A or C'
        };
        extraParams.replacementCostTotal = {
          type: 'integer',
          name: 'Replacement Cost Total'
        };
        break;
      case 'Override Application Signing Expiry':
        extraParams.applicationSigningExpiresAt = {
          type: 'date',
          name: 'New Expiry Date',
          disableFuture: false
        };
        break;
      case 'Override Vehicles Per Driver':
        extraParams.carsToDriversRatio = {
          type: 'integer',
          name: 'Allowed vehicles per driver',
          description:
            'This is a per-driver ratio, not the total number of vehicles on the policy. The policy can carry up to this number times the rated driver count. Example: entering 3 on a policy with 2 drivers allows up to 6 vehicles.'
        };
        break;
    }
  }

  return extraParams;
};
export default useOverridesTaskExtraFields;
